import gql from 'graphql-tag';

export const getWatchlistLevelConfigs = gql(`
  query GetWatchlistLevelConfigs($filter: VisitorWatchlistFilterInput!) {
    getWatchlistLevelConfigs(filter: $filter) {
      id
      organizationId
      level
      displayLevelText
      isNotificationsEnabled
      notificationTargets
      isWatchlistDisplayed
      isApprovalRequired
    }
  }`
);
